import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { WebApiBaseService } from '../../shared/web-api-base/web-api-base.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class InicioService extends WebApiBaseService {


  constructor(private http: HttpClient, private route: Router) {
    super();

  }

 

     setAyudaInicial(valor:boolean): Observable<any> {
      return  this.http.put<any>(this.baseUrl + 'Accounts/SetAyudaInicial',valor
      ).pipe(
          map((response:any)=> {if (response===null) return {};
          return Response;
        })
       );
      }
    
    getClientes(): Observable<any[]> {
           return this.http.get<any[]>(this.baseUrl + 'RelacionEmailPotencialesPjf/ListxAccount');
 

    }}
